import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedSuperBatchGroupModule: null,
  selectedSuperBatchGroupModuleError: null,
  batchDetails: null,
};

export const superBatchGroupModule = createSlice({
  name: 'superBatchGroupModule',
  initialState,
  reducers: {
    setSelectedSuperBatchGroupModuleErrors: (state, action) => {
      state.selectedSuperBatchGroupModule = action.payload;
    },
    setSelectedSuperBatchGroupModule: (state, action) => {
      state.selectedSuperBatchGroupModule = action.payload;
    },
    setBatchDetails: (state, action) => {
      state.batchDetails = action.payload;
    },
  },
});

export const {
  setSelectedSuperBatchGroupModuleErrors,
  setSelectedSuperBatchGroupModule,
  setBatchDetails,
} = superBatchGroupModule.actions;
export default superBatchGroupModule.reducer;
